import React from "react";
import TextField from "@mui/material/TextField";

/**
 * Small, token-based search input used across category/timeline filter UIs.
 * Centralizing it helps keep spacing and colors consistent.
 */
const SearchTextField = ({ value, onChange, placeholder, sx, ...rest }) => {
  return (
    <TextField
      size="small"
      fullWidth
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      sx={{
        mt: 0.5,
        background: "transparent",
        "& .MuiOutlinedInput-root": {
          borderRadius: "var(--radius-md)",
          backgroundColor: "transparent",
          "& fieldset": { borderColor: "var(--border)" },
          "&:hover fieldset": { borderColor: "var(--accent)" },
          "&.Mui-focused fieldset": { borderColor: "var(--accent)" },
        },
        "& input": {
          color: "var(--text)",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "var(--text-faint)",
          opacity: 1,
        },
        ...sx,
      }}
      {...rest}
    />
  );
};

export default SearchTextField;

